<template>
  <div class="container">
    <div :class="{ 'hover-search-fix': topSearchShow }"></div>
    <Spin fix v-if="modelFormShow"></Spin>
    <div class="SaaSbanner">
      <img :src="require('@/assets/images/shujubanner.png')" />
    </div>
    <div class="SaaScontent">
      <div class="SaaStitle flex flex-v flex-align-center">
        <p class="p1">数据中台系统核心能力</p>
      </div>
      <div style="padding: 20px">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6"
                  v-for="(item, index) in SaaSclist"
                  :key="index">
            <div class="SaaScitem flex flex-v flex-align-center">
              <img :src="item.img" width="65" height="65" class="xt" />
              <p class="p1">{{ item.title }}</p>
              <p class="p2">{{ item.content }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      
    </div>
    <div class="SaaSCard">
      <div class="SaaSXITONG">
        <img class="wnsxbg" :src="require('@/assets/images/wnsxbg.png')" />
        <div class="SaaStitle flex flex-v flex-align-center">
          <p class="p1">数据中台系统能为你实现</p>
        </div>
        <div class="SaaSXITONGBOX flex flex-l flex-pack-justify">
          <div class="sl flex flex-v">
            <div
              v-for="(item, index) in Cardlist"
              @click="setCardinfo(item)"
              :key="index"
              class="slitem flex flex-v"
              :class="{ slsjx: Cardinfo.id == item.id }"
            >
              <!-- <div class="slitemsjx"></div> -->
              <img :src="require('@/assets/images/sltop.png')" class="sltop" />
              <img
                v-if="Cardinfo.id == item.id"
                :src="item.checkimg"
                :class="'sl0' + (index + 1)"
              />
              <img v-else :src="item.numimg" :class="'sl0' + (index + 1)" />
              <p class="p1">{{ item.title }}</p>
            </div>
          </div>
          <div class="sr flex flex-v">
            <div class="srbox">
              <img :src="Cardinfo.img" width="820" height="380" />
            </div>
            <div class="srcontent flex flex-v">
              <p class="p1">{{ Cardinfo.title }}</p>
              <p class="p2">{{ Cardinfo.content }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="SaaStitle flex flex-v flex-align-center">
        <p class="p1">供应链管理系统适用行业</p>
      </div>
      <div class="Cardfooter flex flex-l flex-pack-justify">
        <div class="Cardleft flex flex-v flex-pack-justify">
          <div class="Cardt flex flex-l flex-pack-justify">
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter01.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>化工/工业</p>
              </div>
            </div>
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter02.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>建筑建材</p>
              </div>
            </div>
          </div>
          <div class="Cardbottom flex flex-l flex-pack-justify">
            <div class="Cardbottom-l flex flex-v">
              <div class="Carditem2">
                <img
                  :src="require('@/assets/images/Cardfooter03.png')"
                  width="285"
                  height="480"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>原材料</p>
                </div>
              </div>
            </div>
            <div class="Cardbottom-r flex flex-v flex-pack-justify">
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter04.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>快消品</p>
                </div>
              </div>
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter05.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>医药行业</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Cardright flex flex-v flex-pack-justify">
          <div class="Cardt flex flex-l flex-pack-justify">
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter06.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>农林副业</p>
              </div>
            </div>
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter07.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>环保</p>
              </div>
            </div>
          </div>
          <div class="Cardbottom flex flex-v flex-pack-justify">
            <div class="Cardbottom-l flex flex-v">
              <div class="Carditem3">
                <img
                  :src="require('@/assets/images/Cardfooter08.png')"
                  width="590"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>机械设备</p>
                </div>
              </div>
            </div>
            <div class="Cardbottom-r flex flex-l flex-pack-justify">
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter09.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>钢铁行业</p>
                </div>
              </div>
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter10.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>更多行业</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SaaSfooter flex flex-l">
      <div class="SaaSfl flex flex-v flex-align-center">
        <img
          :src="require('@/assets/images/SaaSflimg.png')"
          class="SaaSflimg"
        />
        <p class="pp">1v1按需求定制个性化方案，全程360°为您服务</p>
        <!-- <div class="SaaSflbox flex flex-l flex-pack-justify">
          <div class="flex-text SaaSflitem">
            <img
              :src="require('@/assets/images/dhico.png')"
              width="26"
              height="23"
              class="dhico"
            />
            <p class="p1">0512-56308111</p>
          </div>
          <div class="sline">|</div>
          <div class="flex-text SaaSflitem">
            <img
              :src="require('@/assets/images/dhico2.png')"
              width="20"
              height="20"
              class="dhico"
            />
            <p class="p2">赵经理181-5113-1688</p>
          </div>
        </div> -->
      </div>
      <div class="SaaSfr">
        <img
          :src="require('@/assets/images/SaaSfrimg.png')"
          class="SaaSfrimg"
        />
      </div>
    </div>
    <!-- 底部栏 -->
    <BaseFooter></BaseFooter>
    <!--  -->
  </div>
</template>

<script>
export default {
  name: "Index",
  mounted() {
    var navid = this.$route.params.navid
    if (navid) this.navid = navid
    // this.getIndexData()
    let that = this
    window.onscroll = function () {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(top)
      if (top > 37) {
        that.topSearchShow = true
      } else {
        that.topSearchShow = false
      }
    }

    window.scrollTo(0, 0)
  },
  data() {
    return {
      bannerlist: [
        { img: require("@/assets/images/scmbanner.png") },
        { img: require("@/assets/images/scmbanner2.png") },
        { img: require("@/assets/images/scmbanner3.png") },
        { img: require("@/assets/images/scmbanner4.png") }
      ],
      Cardinfo: {
        id:0,
        numimg: require("@/assets/images/sl01b.png"),
        checkimg: require("@/assets/images/sl01.png"),
        img: require("@/assets/images/cardbg2.png"),
        title: "数据中台：盘活全量数据，构筑坚实壁垒以持续领先",
        content:
          "中台系统通过新技术将数据洞察直接转化为行动，标准数据访问能力大幅提升了数据集成调用操作性，搭建技术与业务的内部沟通桥梁，推动数据与业务场景的融合。"
      },
      Cardlist: [
        {
          id:0,
          numimg: require("@/assets/images/sl01b.png"),
          checkimg: require("@/assets/images/sl01.png"),
          img: require("@/assets/images/cardbg2.png"),
          title: "数据中台：盘活全量数据，构筑坚实壁垒以持续领先",
          content:
            "中台系统打破数据孤岛，降低使用数据服务的门槛，丰富标签数据，完善数据的提炼和分析能力，帮助数据资产持续增值，实现数据“越用越多”的价值闭环。"
        },
        {
          id:1,
          numimg: require("@/assets/images/sl02b.png"),
          checkimg: require("@/assets/images/sl02.png"),
          img: require("@/assets/images/cardbg4.png"),
          title: "数据中台：以数据为基础，推动商业模式创新",
          content:
            "中台系统通过新技术将数据洞察直接转化为行动，标准数据访问能力大幅提升了数据集成调用操作性，搭建技术与业务的内部沟通桥梁，推动数据与业务场景的融合。"
        },
        {
          id:2,
          numimg: require("@/assets/images/sl03b.png"),
          checkimg: require("@/assets/images/sl03.png"),
          img: require("@/assets/images/cardbg5.png"),
          title: "数据中台：以客户为中心，驱动企业稳健前行",
          content:
            "中台系统将全域海量数据转化为高质量数据资产，实现以客户为中心的持续规模化经营，打造核心竞争力，以数据赋能业务创新发展，提供个性化和智能化的业务服务。"
        }
      ],
      SaaSclist: [
        {
          img: require("@/assets/images/sjcj.png"),
          title: "数据采集",
          content:
            "兼具多种数据源的采集能力，实现全端数据资产积累，安全合规，代码埋点、全埋点、可视化全埋点多种方式满足采集"
        },
        {
          img: require("@/assets/images/sjqx.png"),
          title: "数据清洗",
          content:
            "利用数据清洗过滤某些非法的行为数据，并通过标签的值来灵活决定是否需要信任某一条行为数据，提高数据准确性。"
        },
        {
          img: require("@/assets/images/lxjs.png"),
          title: "离线计算",
          content:
            "离线计算是在大量数据上进行复杂的批量运算，能够方便地查询批量计算的结果；数据在计算之前已经完全到位，不会发生变化"
        },
        {
          img: require("@/assets/images/lsjs.png"),
          title: "流式计算",
          content:
            "用户的行为偏好可以在更短的时间内反映在推荐模型中，推荐模型能够以更低的延迟捕捉用户的行为偏好以提供更精准、及时的推荐。"
        },
        {
          img: require("@/assets/images/sjfx.png"),
          title: "数据分析",
          content:
            "数据分析能力让企业随时监控、预测所执行业务与管理的效率和效益，确保企业运营的各业务数据量化、集成和共享，实现智慧协同"
        },
        {
          img: require("@/assets/images/sjxt.png"),
          title: "数据协同",
          content:
            "解决数据处理的效率问题，通过开发平台的方式提升离线分析、实时分析、机器学习、人工智能等数据处理效率，提升数据流通速度"
        },
        {
          img: require("@/assets/images/sjgx.png"),
          title: "数据共享",
          content:
            "提供数据融合、抽取、清洗、实时同步，数据质量管理等可视化配置，批流一体的处理海量数据源，解决数据实时难题"
        },
        {
          img: require("@/assets/images/sjdy.png"),
          title: "数据订阅",
          content:
            "数据到达接收层之后，会被立即写入一个消息队列中，以对下游提供订阅服务。最终落到一个持久化的、高效访问的存储系统中"
        }
      ],
      navid: 0,
      topSearchShow: false, // 滚动后顶部搜索栏展示
      modelFormShow: false
    }
  },
  // created(){

  // },
  methods: {
    setCardinfo(item) {
      if (item) {
        this.Cardinfo = item
      } else {
        this.Cardinfo = {
          id:0,
          numimg: require("@/assets/images/sl01b.png"),
          checkimg: require("@/assets/images/sl01.png"),
          img: require("@/assets/images/cardbg2.png"),
          title: "打通“四流”，提高供应链协同水平",
          content:
            "提升核心企业产业链一体化运作效率；实现商流、物流、信息流、资金流四流合一；借助敏前台、强中台的供应链平台，快速应对复杂的商业场景，优化全流程。"
        }
      }
    }
  },
  components: {
  }
}
</script>

<style scoped lang="scss">
.container {
  box-sizing: border-box;
  background-color: rgba(250, 250, 250, 1);
  transition: 0.35s;
  [data-theme="dark"] & {
      background-color: #1d1d1d;
  }
  [data-theme="light"] & {
      background-color:  rgba(250, 250, 250, 1);
  }
  position: relative;
}
.SaaSbanner {
  width: 100%;
  height: 400px;
  overflow: hidden;
  position: relative;
  // margin-bottom: 82px;
  > img {
    display: block;
    margin: 0 auto;
    width: 1920px;
    height: 400px;
  }
  .SaaSCar {
    width: 1276px;
    height: 118px;
    position: absolute;
    left: 50%;
    bottom: -80px;
    transform: translate(-50%, 0);

    .Caritem {
      width: 304px;
      height: 118px;
      padding: 16px 20px;
      background: #ffffff;
      box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.04);
      .p1 {
        margin-top: 4px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }

      .p2 {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
      > img {
        margin-right: 20px;
      }
      .zy1 {
        width: 90px;
        height: 87px;
      }
      .zy2 {
        width: 104px;
        height: 84px;
      }
      .zy3 {
        width: 107px;
        height: 70px;
      }
      .zy4 {
        width: 90px;
        height: 70px;
      }
    }
  }
}
.SaaScontent {
  max-width: 1200px;
  margin: 0 auto 10px;
  .SaaStitle {
    width: 100%;
    .p1 {
      margin-top: 50px;
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .p2 {
      margin-top: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
    }
  }
  .SaaScitem {
      // cursor: pointer;
      // margin-right: 20px;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      height: 236px;
      background: #ffffff;
      // box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.04);
      padding: 30px 11px 30px 10px;
      box-sizing: border-box;
      .xt {
        width: 65px;
        height: 65px;
      }
      .p1 {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        // margin-top: 10px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }
      .p2 {
        margin-top: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
      .xtmore {
        position: absolute;
        bottom: 20px;
        right: 20px;
        height: 16px;
        .p3 {
          font-size: 12px;
          font-weight: 400;
          color: #ff7f50;
          line-height: 16px;
        }
        .jtimg {
          width: 4px;
          height: 8px;
          margin-left: 5px;
        }
      }
    }
  .SaaSclist {
    margin-top: 80px;
    width: 1220px;
    flex-wrap: wrap;
    
  }
  .fwhy {
    width: 1176px;
    height: 440px;
    margin-left: 12px;
    margin-top: 50px;
  }
}
.SaaSCard {
  width: 100%;
  background-color: #fff;
  .SaaSXITONG {
    width: 100%;
    height: 687px;
    position: relative;
    .wnsxbg {
      width: 1920px;
      max-width: 100%;
      height: 687px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .SaaStitle {
      position: relative;
    }
    .SaaSXITONGBOX {
      
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      margin-top: 30px;
      height: 562px;
      .sl {
        width: 30%;
        .slitem::before{
          position: absolute;
          right: -10px;
          top: 55px;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 10px solid #ff7f50;
        }
        
        .slitem {
          margin-bottom: 20px;
          // height: 120px;
          width: calc(100% - 20px);
          position: relative;
          background: #fff;
          padding-left: 20px;
          padding-bottom: 20px;
          padding-right: 20px;
          color: #333333;
          box-sizing: border-box;
          
          .sl01 {
            width: 68px;
            height: 78px;
          }
          .sl02 {
            width: 89px;
            height: 78px;
          }
          .sl03 {
            width: 87px;
            height: 78px;
          }
          .sltop {
            width: 360px;
            height: 120px;
            position: absolute;
            top: 0;
            left: 0;
          }
          .p1 {
            font-size: 18px;
            font-weight: 400;
            
            line-height: 28px;
          }
        }
        .slsjx{
          color: #ffffff;
          background: #ff7f50;
        }
        .slsjx::before{
          content:'';
          position: absolute;
          right: -14px;
          top: 50%;
          transform: translate(-50%,0);
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 10px solid #ff7f50;
        }
        
      }

      .sr {
        width: 70%;
        .srbox{
          width: 100%;
          height: 380px;
          background: #FFFFFF;
          border-radius: 0px 50px 0px 50px;
          opacity: 1;
          overflow: hidden;

        }
        .srcontent{
          margin-top: 20px;
          background: #FFFFFF;
          border-radius: 20px 20px 20px 20px;
          padding: 25px 30px;
          width: 100%;
          min-height: 162px;
          box-sizing: border-box;
          .p1{
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            line-height: 26px;
          }
          .p2{
            margin-top: 20px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
          }
        }
      }
    }
  }
  .SaaStitle {
    width: 100%;
    .p1 {
      margin-top: 50px;
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .p2 {
      margin-top: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
    }
  }
  .Cardtop {
    width: 1200px;
    height: 720px;
    margin: 30px auto 0;
    position: relative;
    .cardbg1 {
      width: 1200px;
      height: 623px;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    .Cardbox {
      width: 750px;
      height: 392px;
      background: #ffffff;
      box-shadow: 0px -4px 20px 1px rgba(0, 0, 0, 0.03);
      position: relative;
      margin-left: 150px;
      .cardbg2 {
        width: 710px;
        height: 250px;
        margin-top: 20px;
      }
      .Cardboxtext {
        width: 100%;
        height: 122px;
        padding: 20px;
        .p1 {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          line-height: 24px;
          margin-bottom: 15px;
        }
        .p2 {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }
    }

    .Cardlist {
      margin-top: 30px;
      position: relative;
      padding: 0 30px;
      .Carditem {
        cursor: pointer;
        width: 370px;
        height: 270px;
        background: #ffffff;
        box-shadow: 0px -4px 20px 1px rgba(0, 0, 0, 0.03);
        position: relative;
        // margin-left: 150px;
        .cardbg2 {
          width: 330px;
          height: 120px;
          margin-top: 20px;
        }
        .Cardboxtext {
          width: 100%;
          height: 130px;
          padding: 15px 10px 15px 20px;
          .p1 {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 24px;
            margin-bottom: 10px;
          }
          .p2 {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
  }

  .Cardfooter {
    max-width: 1200px;
    margin: 30px auto;
    position: relative;
    .Cardleft {
      width: 50%;
      height: 730px;
      .Cardt {
        width: 100%;
      }

      .Cardbottom-l {
        width: 50%;
        height: 480px;
      }
      .Cardbottom-r {
        width: 50%;
        height: 480px;
      }
      .Carditem2 {
        width: 100%;
        height: 480px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
          // background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
    .Cardright {
      width: 50%;
      height: 730px;
      .Cardt {
        width: 100%;
      }

      .Cardbottom {
        width: 100%;
        height: 480px;
      }

      .Cardbottom-l {
        width: 100%;
        height: 230px;
      }
      .Cardbottom-r {
        width: 100%;
        height: 230px;
      }
      .Carditem3 {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem2 {
        width: 100%;
        height: 480px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
.SaaSfooter {
  margin-top: 50px;
  width: 100%;
  position: relative;
  .fimg {
    width: 100%;
    height: 200px;
  }
  .SaaSfl {
    position: relative;
    width: 50%;
    height: 150px;
    .SaaSflimg {
      width: 100%;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .pp {
      height: 24px;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      line-height: 24px;
      margin-top: 32px;
      position: relative;
    }

    .SaaSflbox {
      position: relative;
      height: 45px;
      width: 510px;
      margin-top: 20px;
      .sline {
        margin: 0 10px 0 6px;
        font-size: 20px;
        font-weight: 400;
        color: #ffd1a3;
        line-height: 45px;
        width: 2px;
        height: 28px;
        opacity: 1;
        // background-color: #ffffff;
      }
      .SaaSflitem {
        height: 45px;
        .p1 {
          margin-left: 5px;
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          line-height: 45px;
        }
        .p2 {
          margin-left: 5px;
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          line-height: 45px;
        }
      }
    }
  }
  .SaaSfr {
    position: relative;
    width: 50%;
    height: 150px;
    .SaaSfrimg {
      width: 100%;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
.paddingfix {
  padding-top: 0 !important;
}
</style>
<style>
.hover-search-fix {
  width: 100%;
  height: 74px;
}
.hover-search {
  width: 100%;
  height: 74px;
  transform: translateY(-200px);
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 9999;
  box-shadow: 0 0 10px 2px rgb(90 90 90 / 60%);
  /* transition: 0.35s; */
}
.show {
  transform: translateY(0);
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  top: 0;
}
.SaaSbanner .ivu-carousel-dots-inside {
  bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/jtjc/CloudSaaS5.vue